// Step-navigation gating for the producer wizard (CreateEditBriefing).
//
// A step is "unlocked" — reachable from the left-hand step nav — once
// the producer has legitimately reached it via the validated Next
// button (tracked as `maxStepReached`). This stops a jump from step 1
// straight to step 8 that would skip required info (e.g. the crew data
// live-tracking setup depends on), while letting the producer freely hop
// between steps they have already completed. Existing productions unlock
// every step, since their data already exists.

export type StepStatus = "current" | "done" | "available" | "locked";

/** True when `target` may be navigated to from the step nav. */
export function isStepUnlocked(target: number, maxStepReached: number): boolean {
  return target >= 0 && target <= maxStepReached;
}

/**
 * Display status for a step in the nav: the active step, an earlier
 * completed step, a later-but-reachable step, or a still-locked step.
 */
export function stepStatus(step: number, currentStep: number, maxStepReached: number): StepStatus {
  if (step === currentStep) return "current";
  if (!isStepUnlocked(step, maxStepReached)) return "locked";
  return step < currentStep ? "done" : "available";
}
